import type { PayoffDateConstraintStrategy } from './date-constraint-strategy';
import { DefaultDateConstraintStrategy } from './default-date-constraint.strategy';
import { MichiganDateConstraintStrategy } from './michigan-date-constraint.strategy';

const STATE_STRATEGY_MAP: Record<string, () => PayoffDateConstraintStrategy> = {
  MI: () => new MichiganDateConstraintStrategy(),
};

export function resolveDateConstraintStrategy(propertyState?: string): PayoffDateConstraintStrategy {
  const normalizedState = propertyState?.toUpperCase();
  const factory = normalizedState ? STATE_STRATEGY_MAP[normalizedState] : undefined;
  return factory ? factory() : new DefaultDateConstraintStrategy();
}
